import { RADIO_STATION_ACTIONS } from '../Actions/RadioStationAction';

// Initial States
const radioStationsInitialState = {
    stations: [],
    loading: false,
    error: null,
    searchTerm: '',
    categoryFilter: '',
    languageFilter: '',
    pagination: {
        total: 0,
        limit: 9,
        offset: 0,
        hasMore: false
    }
};

const radioStationDetailsInitialState = {
    station: null,
    loading: false,
    error: null,
    epg: {
        data: null,
        loading: false,
        error: null
    }
};

const radioPlayerInitialState = {
    currentStation: null,
    volume: 80,
    isMuted: false,
    showEPGModal: false,
    showQueueModal: false,
    isPlayerVisible: false
};

/**
 * Radio Stations List Reducer
 */
export const radioStationsReducer = (state = radioStationsInitialState, action) => {
    switch (action.type) {
        case RADIO_STATION_ACTIONS.GET_RADIO_STATIONS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_STATIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                stations: action.payload.stations,
                pagination: action.payload.pagination,
                searchTerm: action.payload.searchTerm,
                categoryFilter: action.payload.categoryFilter,
                languageFilter: action.payload.languageFilter
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_STATIONS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                stations: []
            };
            
        case RADIO_STATION_ACTIONS.CLEAR_RADIO_STATIONS:
            return radioStationsInitialState;
            
        default:
            return state;
    }
};

/**
 * Radio Station Details Reducer
 */
export const radioStationDetailsReducer = (state = radioStationDetailsInitialState, action) => {
    switch (action.type) {
        case RADIO_STATION_ACTIONS.GET_RADIO_STATION_DETAILS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_STATION_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                station: action.payload
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_STATION_DETAILS_FAILED:
            return {
                ...state,
                loading: false,
                error: action.payload,
                station: null
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_EPG_START:
            return {
                ...state,
                epg: {
                    ...state.epg,
                    loading: true,
                    error: null
                }
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_EPG_SUCCESS:
            return {
                ...state,
                epg: {
                    data: action.payload,
                    loading: false,
                    error: null
                }
            };
            
        case RADIO_STATION_ACTIONS.GET_RADIO_EPG_FAILED:
            return {
                ...state,
                epg: {
                    ...state.epg,
                    loading: false,
                    error: action.payload
                }
            };
            
        case RADIO_STATION_ACTIONS.CLEAR_RADIO_STATION_DETAILS:
            return radioStationDetailsInitialState;
            
        default:
            return state;
    }
};

/**
 * Radio Player Reducer - Works alongside music player
 */
export const radioPlayerReducer = (state = radioPlayerInitialState, action) => {
    switch (action.type) {
        case RADIO_STATION_ACTIONS.SET_RADIO_CURRENT_STATION:
            return {
                ...state,
                currentStation: action.payload,
                isPlayerVisible: !!action.payload
            };
            
        case RADIO_STATION_ACTIONS.SET_RADIO_VOLUME:
            return {
                ...state,
                volume: action.payload
            };
            
        case RADIO_STATION_ACTIONS.SET_RADIO_MUTED:
            return {
                ...state,
                isMuted: action.payload
            };
            
        case RADIO_STATION_ACTIONS.TOGGLE_RADIO_EPG_MODAL:
            return {
                ...state,
                showEPGModal: action.payload,
                // Close queue modal if EPG is opening
                showQueueModal: action.payload ? false : state.showQueueModal
            };
            
        case RADIO_STATION_ACTIONS.TOGGLE_RADIO_QUEUE_MODAL:
            return {
                ...state,
                showQueueModal: action.payload,
                // Close EPG modal if queue is opening
                showEPGModal: action.payload ? false : state.showEPGModal
            };
            
        case RADIO_STATION_ACTIONS.TOGGLE_RADIO_PLAYER:
            return {
                ...state,
                isPlayerVisible: action.payload
            };
            
        // Handle music player actions to maintain unified state
        case 'GET_CURRENT_SUCCESS':
            // If switching to music, clear current radio station
            if (action.payload?.source_type !== 'RADIO') {
                return {
                    ...state,
                    currentStation: null,
                    isPlayerVisible: false
                };
            }
            return state;
            
        case 'OPEN_PLAYLIST':
            return {
                ...state,
                isPlayerVisible: action.payload
            };
            
        default:
            return state;
    }
};

/**
 * Combined Radio Reducer - Combines all radio-related reducers
 */
export const radioReducer = (state = {}, action) => {
    return {
        stations: radioStationsReducer(state.stations, action),
        stationDetails: radioStationDetailsReducer(state.stationDetails, action),
        player: radioPlayerReducer(state.player, action)
    };
};

export default radioReducer;